import React from "react";

// const loadableReady = require("@loadable/component").loadableReady;

export const wrapPageElement = ({ element }) => element;

// export const replaceHydrateFunction = () => {
//   return (element, container, callback) => {
//     loadableReady(() => {
//       ReactDOM.render(element, container, callback);
//     });
//   };
// };
